module.exports = __webpack_public_path__ + "img/banner.da390f88.png";